import { emptyChecklistItemHelper } from '@/utils';
import { titles } from '@/services/checks/component.checks';

const TRANSITION_DELAY = 800;

export default (context: any) => ({
  [titles.IMAGERY]() {
    context.selectPanel('assets');
    setTimeout(() => {
      context
        .$refs
        .assetManager
        .$el
        .querySelector('.asset-manager-add')
        .click();
    }, TRANSITION_DELAY);
  },
  [titles.PRICING]: () => emptyChecklistItemHelper(context, 'prices'),
  [titles.PROPERTIES]: () => emptyChecklistItemHelper(context, 'properties'),
  [titles.NAME]() {
    // focus on field
    context.selectPanel('info');
    setTimeout(() => {
      context
        .$el
        .querySelector('.field-name input')
        .focus();
    }, TRANSITION_DELAY);
  },
  [titles.VENDORS]() {
    context.selectPanel('vendors');
  },
});
